const colors = {
  black: '#2A2A34',
  white: '#FFF',
  offWhite: '#F2F9FD',
  pink: '#fc425d',
  green: '#62ebc4',
  teal: '#465E69',
  lightGrey: '#E8F0FE',
}
const sizes = {
  mWide: '1440px',
  mLarge: '1200px',
  mDesktop: '1024px',
  mMedium: '900px',
  mTablet: '768px',
  mPhablet: '650px',
  mPhone: '500px',
  mSmall: '400px',
  mSmaller: '320px',
}

export {colors, sizes}
